import { render } from "./MultiStepsProgress.vue?vue&type=template&id=0c05663b&scoped=true"
import script from "./MultiStepsProgress.vue?vue&type=script&lang=js"
export * from "./MultiStepsProgress.vue?vue&type=script&lang=js"

import "./MultiStepsProgress.vue?vue&type=style&index=0&id=0c05663b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c05663b"

export default script